import { motion } from 'framer-motion'
import { useRecoilValue } from 'recoil'
import { publicIsLoggedIn } from '@/store/onepager/onepager'
import { RiDownloadLine } from 'react-icons/ri'
function LowerBar({ hideBar, showSignUp, collection }) {
  const isLoggedIn = useRecoilValue(publicIsLoggedIn)

  if (isLoggedIn) {
    return null
  } else {
    return (
      <div
        className="fixed bottom-0 inset-x-0 pb-2 sm:pb-5 z-50 lowerBanner"
        style={{ zIndex: '1999' }}
      >
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          transition={{ duration: 0.15 }}
          variants={{
            hidden: {
              opacity: 0,
              y: 50,
            },
            visible: {
              opacity: 1,
              y: 0,
            },
            exit: {
              opacity: 0,
              y: 50,
            },
          }}
          className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8"
        >
          <div className="p-2 rounded bg-black text-white border-2 border-black shadow-lg sm:p-3">
            <div className="flex flex-col md:flex-row items-center justify-between flex-wrap">
              <div className="hidden md:flex flex-shrink-0  items-center">
                {/* <span className="flex  items-center rounded ">
                  <img
                    className="h-8 w-8 "
                    src="https://cdn.filestackcontent.com/jW9hY5L5RAWWpn2rGhw9"
                  />
                  <span className=" font-bold ml-3">Onepager.io</span>
                </span> */}
                {/* {collection.promoted && (
                  <span className="flex  items-center rounded ">
                    <img
                      className="h-8 w-8 "
                      src="https://cdn.filestackcontent.com/jW9hY5L5RAWWpn2rGhw9"
                    />
                    <span className=" font-bold ml-3">
                      Onepager.io
                    </span>
                  </span>
                )}
                {!collection.promoted && (
                  <span className="flex  items-center rounded ">
                    {collection.logo && (
                      <img
                        className="h-8 w-auto md:mb-0 ml-2"
                        src={collection.logo}
                      />
                    )}
                    {collection.brand && (
                      <h2 className=" font-bold ml-3">{collection.brand}</h2>
                    )}
                    {!collection.brand && !collection.logo && (
                      <h2 className=" font-bold ml-3">{collection.title}</h2>
                    )}
                  </span>
                )} */}
                <span className="text-lg font-bold ml-2">
                  Save Your Changes - Sign Up or Login To View Saved Data
                </span>
              </div>

              <div className="hidden md:flex flex-shrink-0  items-center sm:order-3 sm:ml-2">
                <div className="px-5 mr-3 md:px-0 mb-3 md:mb-0 hidden md:block font-medium text-center md:text-left ">
                  {/* <span className="text-sm  md:text-lg">
                    Save Your Changes by Creating Your Own Onepager Account
                  </span> */}
                  {/* {collection.promoted && (
                    <span className="text-sm  md:text-lg">
                      Save Your Changes by Creating Your Own Onepager Account
                    </span>
                  )}
                  {!collection.promoted && (
                    <span className="text-sm  md:text-lg">
                      Save Your Changes by Signing Up
                    </span>
                  )} */}
                </div>

                <div className=" mt-2 flex space-x-2 sm:mt-0 sm:w-auto">
                  <a
                    onClick={() => {
                      showSignUp()
                      // analytics.track('Save To Account Lower Banner Click')
                    }}
                    className="flex items-center cursor-pointer justify-center px-4 py-2 border border-transparent rounded-md shadow-sm  font-bold text-black bg-yellow-400"
                  >
                    Save &amp; Sign Up
                  </a>
                  <a
                    onClick={() => {
                      showSignUp('login')
                      // analytics.track('Save To Account Lower Banner Click')
                    }}
                    className="flex items-center cursor-pointer justify-center px-4 py-2 border border-transparent rounded-md shadow-sm  font-bold text-black bg-yellow-400"
                  >
                    Login
                  </a>
                  {/* {collection.promoted && (
                    <a
                      onClick={() => {
                        showSignUp()
                      }}
                      className="flex items-center cursor-pointer justify-center px-4 py-2 border border-transparent rounded-md shadow-sm  font-bold text-white bg-gray-700 hover:bg-yellow-400 hover:text-black"
                    >
                      Sign Up Or Login
                    </a>
                  )}
                  {!collection.promoted && (
                    <a
                      onClick={() => {
                        showSignUp()
                      }}
                      className="flex items-center cursor-pointer justify-center px-4 py-2 border border-transparent rounded-md shadow-sm  font-bold text-white bg-gray-700 hover:bg-yellow-400 hover:text-black"
                    >
                      Sign Up
                    </a>
                  )} */}
                </div>
                <button
                  onClick={() => {
                    hideBar()
                    // analytics.track('Hide Signup Lower Banner')
                  }}
                  type="button"
                  className="-mr-1 flex p-2 rounded-md hover:bg-gray-700 hover:bg-opacity-50 focus:outline-none focus:ring-2 focus:ring-white"
                >
                  <span className="sr-only">Dismiss</span>
                  <svg
                    className="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div className="flex justify-between md:hidden py-2 px-3 flex-shrink-0  items-center sm:order-3 sm:ml-2">
                <div className=" flex-shrink-0 sm:mt-0 sm:w-auto">
                  <a
                    onClick={() => {
                      showSignUp()
                      // analytics.track(
                      //   'Mobile Save-to-Account Lower Banner Click'
                      // )
                    }}
                    className="flex items-center cursor-pointer justify-center px-4 py-2 border border-transparent rounded-md shadow-sm  font-bold text-white bg-gray-700 hover:bg-yellow-400 hover:text-black"
                  >
                    <RiDownloadLine className="mr-2" />
                    Save To Account
                  </a>
                </div>
                <a
                  onClick={() => {
                    // analytics.track('Mobile OnePager Logo Lower Banner Click')
                  }}
                  href="https://onepager.io"
                  target="_blank"
                  className="flex ml-3  items-center rounded "
                >
                  <img
                    className="h-5 w-5 text-white"
                    src="https://cdn.filestackcontent.com/jW9hY5L5RAWWpn2rGhw9"
                  />
                  <span className="text-white text-sm font-bold ml-3">
                    onepager.io
                  </span>
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    )
  }
}

export default LowerBar
